import React from "react";
import { Button, Form, Input } from "antd";

interface AuthFormProps {
  formType: "signup" | "login";
  onSubmit: (payload: {
    fullName?: string;
    email?: string;
    password?: string;
  }) => void;
}

const AuthForm: React.FC<AuthFormProps> = ({ formType, onSubmit }) => {
  const [form] = Form.useForm();

  const handleFormSubmit = async (values: any) => {
    const payload = {
      fullName: formType === "signup" ? values?.fullName : undefined,
      email: formType === "login" ? values?.email : undefined,
      password: formType === "login" ? values?.password : undefined,
    };
    onSubmit(payload);
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
        }}
      >
        <h1 style={{ fontSize: "36px", fontWeight: "bold", lineHeight: "1.4" }}>
          {formType === "signup"
            ? "The Savings Solution You have Been Waiting For!"
            : "Welcome Back!"}
        </h1>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f9f9f9",
        }}
      >
        <div style={{ width: "100%", maxWidth: "400px" }}>
          <p
            style={{
              marginBottom: "20px",
              textAlign: "center",
              fontWeight: "bolder",
              fontSize: "30px",
            }}
          >
            {formType === "signup"
              ? "Let's get started"
              : "Log in to your account"}
          </p>
          <Form
            form={form}
            name={`${formType}_form`}
            onFinish={handleFormSubmit}
            layout="vertical"
            initialValues={{ remember: true }}
          >
            {formType === "signup" && (
              <Form.Item
                label="Full Name"
                name="fullName"
                className="formControl"
                rules={[
                  { required: true, message: "Please input your full name!" },
                ]}
              >
                <Input placeholder="eg. Enter your name" />
              </Form.Item>
            )}
            <Form.Item
              label="Email"
              name="email"
              initialValue={"admin@yopmail.com"}
              className="formControl"
              rules={[{ required: true, message: "Please input your Email!" }]}
            >
              <Input placeholder="Enter Email" />
            </Form.Item>

            {formType === "login" && (
              <Form.Item
                label="Password"
                name="password"
                initialValue={"admin@123"}
                className="formControl"
                rules={[
                  { required: true, message: "Please input your Password!" },
                ]}
              >
                <Input placeholder="Enter Password" />
              </Form.Item>
            )}

            <Form.Item>
              <Button
                className="btn btn-primary w-100 mt-15 text-right"
                type="primary"
                htmlType="submit"
                block
              >
                {formType === "signup" ? "Continue" : "Log In"}
              </Button>
            </Form.Item>

            <p style={{ fontSize: "12px", textAlign: "center" }}>
              By clicking Continue, you agree to our{" "}
              <a href="/">Code of Conduct</a>, <a href="/">Terms of Service</a>,
              and <a href="/">Privacy Policy</a>.
            </p>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
